import { UserNotificationDTO } from "./UserNotificationDTO";

const WEEKDAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const MONTH = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export class Notification {
  date: string;
  time: string;
  constructor(private _userNotificationDTO: UserNotificationDTO) {
    const dateObj = new Date(this.createdAt);
    const todayObj = new Date();
    this.date = this.dateObjIsToday(dateObj, todayObj)
      ? "Today"
      : `${WEEKDAY[dateObj.getDay()]} ${
          MONTH[dateObj.getMonth()]
        } ${dateObj.getDate()}`;

    let hour = dateObj.getHours();
    let minutes = dateObj.getMinutes();

    const hourFormat = hour < 12 ? "am" : "pm";
    hour = hour == 0 ? 12 : hour;
    hour = hour > 12 ? hour - 12 : hour;
    const minuteString = `${minutes > 9 ? minutes : "0" + minutes}`;
    this.time = `${hour}:${minuteString}${hourFormat}`;
  }

  get message() {
    return this._userNotificationDTO.message;
  }

  get userID() {
    return this._userNotificationDTO.user_id;
  }

  get createdAt() {
    return this._userNotificationDTO.created_at;
  }

  get accountAppID() {
    return this._userNotificationDTO.account_app_id;
  }

  get key() {
    return this._userNotificationDTO.key;
  }

  get id() {
    return this._userNotificationDTO.id;
  }

  get payload() {
    return this._userNotificationDTO.payload;
  }

  get viewed() {
    return this._userNotificationDTO.viewed;
  }

  set viewed(value) {
    this._userNotificationDTO.viewed = value;
  }

  get userNotificationDTO() {
    return this._userNotificationDTO;
  }

  private dateObjIsToday(dateObj: Date, todayObj: Date) {
    return (
      dateObj.getDate() === todayObj.getDate() &&
      dateObj.getMonth() === todayObj.getMonth() &&
      dateObj.getFullYear() === todayObj.getFullYear()
    );
  }
}
